import { createFileRoute } from '@tanstack/react-router';
import VehicleArchive from '../../components/VehiclesSettings/VehicleArchive';
import { PERMISSION_VEHICLE } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/cars_settings/archive')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_VEHICLE, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'vehicles.archive.tab',
        suffix: 'menu.settings',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: VehicleArchiveRoute,
});

function VehicleArchiveRoute() {
  return <VehicleArchive />;
}
